import axiosInstance from '../api/axiosInstance';

const orderService = {
    /**
     * Yeni sipariş oluşturur
     * @param {object} orderData - Sipariş bilgileri
     * @param {string} orderData.paymentMethod - Ödeme yöntemi (PaymentMethod enum değeri)
     * @param {Array} orderData.items - Sepet öğeleri
     * @param {object} orderData.shippingAddress - Teslimat adresi
     * @param {string} orderData.notes - Sipariş notları
     */
    createOrder: async (orderData) => {
        const response = await axiosInstance.post('/orders/create', orderData);
        return response.data;
    },

    /**
     * Kullanıcının siparişlerini getirir
     */
    getUserOrders: async () => {
        const response = await axiosInstance.get('/orders/my-orders');
        return response.data;
    },

    /**
     * Sipariş detaylarını getirir
     * @param {string} orderId - Sipariş ID
     */
    getOrderDetails: async (orderId) => {
        const response = await axiosInstance.get(`/orders/${orderId}`);
        return response.data;
    },
    
    /**
     * Sipariş durumunu günceller
     * @param {string} orderId - Sipariş ID
     * @param {string} status - Yeni sipariş durumu (OrderStatus enum değeri)
     */
    updateOrderStatus: async (orderId, status) => {
        const response = await axiosInstance.put(`/orders/${orderId}/status`, { status });
        return response.data;
    },
    
    /**
     * Kargo fiyatını hesaplar
     * @param {number} totalWeight - Toplam ağırlık (kg)
     */
    calculateShippingCost: async (totalWeight) => {
        const response = await axiosInstance.post('/shippingcosts/calculate', { 
            totalWeight 
        });
        return response.data;
    },
    
    /**
     * Siparişi iptal eder
     * @param {string} orderId - Sipariş ID
     * @param {string} reason - İptal nedeni (opsiyonel)
     */
    cancelOrder: async (orderId, reason = "customer_requested") => {
        // Kullanıcı IP adresini almak için bir API kullanabiliriz
        // Ancak bu bir örnek olduğu için burada doldurulmuş bir değer atıyoruz
        // Gerçek uygulamada IP adresi server-side olarak alınabilir
        
        // IP adresini almak için basit bir hizmet kullanabiliriz
        let clientIp = "127.0.0.1"; // Varsayılan değer
        
        try {
            // https://api.ipify.org gibi bir servis kullanarak IP adresini alabiliriz
            const ipResponse = await fetch('https://api.ipify.org?format=json');
            const ipData = await ipResponse.json();
            clientIp = ipData.ip;
        } catch (error) {
            console.error("IP adresi alınamadı:", error);
        }
        
        const response = await axiosInstance.put(`/orders/${orderId}/cancel`, { 
            reason,
            clientIp 
        });
        return response.data;
    }
};

export default orderService; 